module.exports = {"532623101":"西洒镇","532623102":"兴街镇","532623201":"蚌谷乡","532623202":"莲花塘乡","532623203":"新马街乡","532623204":"柏林乡","532623205":"法斗乡","532623206":"董马乡","532623207":"鸡街乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532623.json
// module id = 2775
// module chunks = 0